// extracted by mini-css-extract-plugin
export default {"container":"ePHAN2tV","link":"VwERlEqJ","error-text":"hSyU9AgW","errorText":"hSyU9AgW","copy-button":"TVLh0nhD","copyButton":"TVLh0nhD","icon":"_PXApNqP"};